<template>
  <div id="form">
    <h1>Adicionar Emprego</h1>
    <form v-on:submit.prevent="addJobs()">
      <div class="form-group">
        <label for="name">Nome do Emprego*</label>
        <input
          type="text"
          class="form-control"
          id="name"
          placeholder="Ex:Software Developer"
          v-model="title"
          required
        />
      </div>
      <div class="form-group">
        <label for="description">Descrição do Emprego*</label>
        <vue-editor
          id="description"
          v-model="description"
          :editor-toolbar="customToolbar"
          required
        ></vue-editor>
      </div>
      <div class="form-group">
        <label for="profile">Perfil do Candidato*</label>
        <vue-editor
          id="profile"
          v-model="profile"
          :editor-toolbar="customToolbar"
          required
        ></vue-editor>
      </div>
      <div class="form-group">
        <label for="offer">Ofertas para o Candidato*</label>
        <vue-editor
          id="offer"
          v-model="offer"
          :editor-toolbar="customToolbar"
          required
        ></vue-editor>
      </div>
      <div class="form-group">
        <label for="state">Estado*</label>
        <select class="form-control" id="state" v-model="state">
          <option value="0">Disponível</option>
          <option value="1">Indisponível</option>
        </select>
      </div>
      <small>*Campos obrigatórios</small> <br />
      <button type="submit" class="btn btn-primary float-right">
        Adicionar
      </button>
    </form>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  components: { VueEditor },
  data: function() {
    return {
      title: "",
      description: "",
      profile: "",
      offer: "",
      state: 0,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4] }],
        ["bold", "italic", "underline"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["code-block"],
      ],
    };
  },
  methods: {
    async addJobs() {
      if ((this.profile = "" || this.description == "")) {
        this.$swal({
          title: "Campos Obrigatórios Vazios",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      } else {
        this.$swal({
          title: "Quer adicionar o trabalho?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, Adicionar!",
        }).then((result) => {
          if (result.isConfirmed) {
            try {
              this.$store.dispatch("postJobs", {
                name: this.title,
                description: this.description,
                profile: this.profile,
                offer: this.offer,
                state: this.state,
              });
              this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 1500,
                icon: "success",
                title: "Trabalho Criado!",
              });
              this.title = "";
              this.description = "";
              this.profile = "";
              this.offer = "";
              this.state = "";
            } catch (err) {
              this.$swal({
                title: err.data.status,
                icon: "error",
                confirmButtonText: "Ok!",
              });
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped>
label {
  font-size: 18px;
}
#form {
  text-align: left;
  padding: 50px 60px 60px 300px;
}
</style>
